exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-2e4d6275]{border-bottom:1px solid #ff7516}.v-btn:not(.v-btn--round).v-size--default[data-v-2e4d6275]{height:36px;min-width:32px;padding:0 12px}", ""]);

// exports
